<script>
  import { layoutMethods  } from "@/state/helpers";
  import tableTab from "@/views/pages/kankolek/cifTab/mobileNumber.vue";
  import logsTab from "@/views/pages/kankolek/cifTab/logs.vue";

  /**
   * CIF Mobile Number component
   */
  export default {
    page: {
      title: "CIF Mobile Number"
    },
    components: {
      tableTab,
      logsTab
    },
    computed: {
    },
    data() {
      return {
        title: "CIF Mobile Number",
        currentView:"tableTab"
      };
    },
    methods: {
      ...layoutMethods,
      changeCurrentView(view){
        this.currentView = view;
      }
    },
    async mounted(){
      this.changeTitle({title: 'CIF Mobile Number'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Kankolek', to: { name: ''} },
          { text: 'CIF Mobile Number', to: { name: 'CIF Mobile Number'} }
        ]
      });
      this.changeCurrentView('tableTab');
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                  <b-tabs content-class="text-muted" nav-class="nav-tabs-custom">
                    <b-tab @click="changeCurrentView('tableTab')" active class="border-0">
                      <template v-slot:title>
                        <span>CIF Mobile Number</span>
                      </template>
                    </b-tab>
                    <b-tab @click="changeCurrentView('logsTab')" class="border-0">
                      <template v-slot:title>
                        <span>Logs</span>
                      </template>
                    </b-tab>
                    
                  </b-tabs>
                  <div class="py-3">
                    <component v-bind:is="currentView"></component>
                  </div>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>